import { FaChartBar, FaChartLine, FaChartPie, FaBox, FaThermometerHalf, FaTable, FaBoxOpen, FaTachometerAlt, FaTextHeight } from "react-icons/fa";
import { IoIosListBox, IoMdNotificationsOutline } from "react-icons/io";
import { TbChartHistogram, TbFileTypeHtml } from "react-icons/tb";
import { GiChemicalTank } from "react-icons/gi";

export const componentsOptions = [
  {
    value: "bar",
    label: "Bar Graph",
    icon: <FaChartBar />,
    subtitle: "Display a Bar Chart",
    minHeight: 250,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "comboBar",
    label: "Combo Bar / Line Chart Graph",
    icon: <TbChartHistogram />,
    subtitle: "Display Bar And Line Combo Chart",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "axis", "timeFrame"],
  },
  {
    value: "line",
    label: "Line Graph",
    icon: <FaChartLine />,
    subtitle: "Display a Line Chart",
    minHeight: 250,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "pie",
    label: "Pie Graph",
    icon: <FaChartPie />,
    subtitle: "Display a Pie Chart",
    minHeight: 250,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "tank",
    label: "3D Fuel Tank",
    icon: <GiChemicalTank />,
    subtitle: "Display a 3D Fuel Tank",
    minHeight: 250,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "counter",
    label: "Counter",
    icon: <IoIosListBox />,
    subtitle: "Display a Counter",
    minHeight: 100,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "splitCounter",
    label: "Split Counter",
    icon: <FaBox />,
    subtitle: "Display a Split Counter",
    minHeight: 125,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "dial",
    label: "Dial",
    icon: <FaTachometerAlt />,
    subtitle: "Display a Dial",
    minHeight: 330,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "table",
    label: "Table",
    icon: <FaTable />,
    subtitle: "Display a Table",
    minHeight: 350,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "dynamicBox",
    label: "Dynamic Box",
    icon: <FaBoxOpen />,
    subtitle: "Display a Dynamic Box",
    minHeight: 250,
    tabs: ["basic", "timeFrame"],
  },
  // {
  //   value: "loadSummary",
  //   label: "Summary Card",
  //   icon: <FaBolt />,
  //   subtitle: "Display Load, Peak Demand & Efficiency",
  //   minHeight: 200,
  //   tabs: ["basic", "timeFrame"],
  // },
  {
    value: "thermometer",
    label: "Thermometer Gauges",
    icon: <FaThermometerHalf />,
    subtitle: "Display Thermometer Gauges",
    minHeight: 250,
    tabs: ["basic", "timeFrame"],
  },
  {
    value: "textBox",
    label: "Text Box",
    icon: <FaTextHeight />,
    subtitle: "Display a Text Box",
    minHeight: 150,
    tabs: ["basic"],
  },
  {
    value: "alarmNotification",
    label: "Alarm Notification",
    icon: <IoMdNotificationsOutline />,
    subtitle: "Display Device Offline & Alarm Notifications",
    minHeight: 250,
    tabs: ["basic", "data"],
  },
  {
    value: "html",
    label: "Custom HTML",
    icon: <TbFileTypeHtml />,
    subtitle: "Display Custom HTML",
    minHeight: 250,
    tabs: ["basic"],
  },
];

export const modalTabs = {
  basic: {
    key: "basic",
    label: "Basic",
  },
  data: {
    key: "data",
    label: "Data",
  },
  appearance: {
    key: "appearance",
    label: "Appearance",
  },
  axis: {
    key: "axis",
    label: "Axis",
  },
  timeFrame: {
    key: "timeFrame",
    label: "Time Frame",
  },
  gauge: {
    key: "gauge",
    label: "Gauge",
  },
  counter: {
    key: "counter",
    label: "Counter",
  },
  editor: {
    key: "editor",
    label: "Editor",
  },
};

export const getModalTabs = (component) => {
  const arr = component?.tabs?.map((tabKey) => modalTabs[tabKey]) || [];
  return arr;
};
